module.exports = __webpack_public_path__ + "img/logo.e3c46f5b.png";